import React from 'react';

export const search = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.1429 3.42847C6.88239 3.42847 3.42859 6.88227 3.42859 11.1428C3.42859 15.4032 6.88239 18.857 11.1429 18.857C12.9643 18.857 14.6383 18.2258 15.958 17.1701L19.9654 21.1774C20.3001 21.5122 20.8428 21.5122 21.1775 21.1774C21.5123 20.8427 21.5123 20.3 21.1775 19.9652L17.1702 15.9579C18.2259 14.6382 18.8572 12.9642 18.8572 11.1428C18.8572 6.88227 15.4034 3.42847 11.1429 3.42847ZM11.1429 5.14275C7.82917 5.14275 5.14287 7.82904 5.14287 11.1428C5.14287 14.4565 7.82917 17.1428 11.1429 17.1428C14.4566 17.1428 17.1429 14.4565 17.1429 11.1428C17.1429 7.82904 14.4566 5.14275 11.1429 5.14275Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const searchLikeFilledOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 6.90022C12 4.73312 13.7753 3 15.9219 3C16.8945 3 17.7555 3.33622 18.4954 3.93721C19.2329 3.33412 20.0977 3 21.0781 3C23.2247 3 25 4.73312 25 6.90022C25 8.02712 24.6942 8.91826 23.9688 9.81635C23.3036 10.6399 22.2749 11.4777 20.8935 12.5589L20.8904 12.5614L19.4615 13.6707C18.8959 14.1098 18.1041 14.1098 17.5385 13.6707L16.1096 12.5614L16.1065 12.5589C14.7251 11.4777 13.6964 10.6399 13.0312 9.81635C12.3058 8.91826 12 8.02712 12 6.90022Z'
        fill='#023F80'
      />
      <path
        d='M9.54851 6.90846C10.0287 6.6357 10.1969 6.02528 9.92415 5.54505C9.65138 5.06483 9.04096 4.89665 8.56073 5.16942C5.83938 6.71515 4 9.64213 4 13C4 17.9706 8.02944 22 13 22C15.1256 22 17.0784 21.263 18.6176 20.0318L23.2929 24.7071C23.6834 25.0976 24.3166 25.0976 24.7071 24.7071C25.0976 24.3166 25.0976 23.6834 24.7071 23.2929L20.0318 18.6176C20.3884 18.1717 20.7035 17.6913 20.9711 17.1822C21.2281 16.6933 21.0401 16.0887 20.5512 15.8317C20.0623 15.5748 19.4577 15.7628 19.2008 16.2516C18.0283 18.4823 15.6906 20 13 20C9.13401 20 6 16.866 6 13C6 10.3906 7.42728 8.11333 9.54851 6.90846Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const searchLikeOutline = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M15.9219 4C14.3177 4 13 5.29524 13 6.90022C13 8.7023 13.9167 9.57518 16.7228 11.7715L18.1517 12.8808C18.3565 13.0397 18.6435 13.0397 18.8483 12.8808L20.2772 11.7715C23.0833 9.57518 24 8.7023 24 6.90022C24 5.29524 22.6823 4 21.0781 4C20.0851 4 19.2257 4.45052 18.5 5.35156C17.759 4.45052 16.8997 4 15.9219 4Z'
        stroke='#023F80'
        stroke-width='2'
        stroke-linejoin='round'
      />
      <path
        d='M9.05462 6.03894C6.63333 7.41424 5 10.0164 5 13C5 17.4183 8.58172 21 13 21C16.0765 21 18.7475 19.2634 20.0859 16.7169'
        stroke='#023F80'
        stroke-width='2'
        stroke-linecap='round'
      />
      <path
        d='M19 19L24 24'
        stroke='#023F80'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 6.90022C12 4.73312 13.7753 3 15.9219 3C16.8945 3 17.7555 3.33622 18.4954 3.93721C19.2329 3.33412 20.0977 3 21.0781 3C23.2247 3 25 4.73312 25 6.90022C25 8.02712 24.6942 8.91826 23.9688 9.81635C23.3036 10.6399 22.2749 11.4777 20.8935 12.5589L20.8904 12.5614L19.4615 13.6707C18.8959 14.1098 18.1041 14.1098 17.5385 13.6707L16.1096 12.5614L16.1065 12.5589C14.7251 11.4777 13.6964 10.6399 13.0312 9.81635C12.3058 8.91826 12 8.02712 12 6.90022ZM15.9219 5C14.8601 5 14 5.85737 14 6.90022C14 7.5754 14.1525 8.02173 14.587 8.55968C15.0815 9.17191 15.9138 9.86839 17.3376 10.9828L17.3391 10.984L18.5 11.8852L19.6609 10.984L19.6624 10.9827C21.0862 9.86837 21.9185 9.17191 22.413 8.55968C22.8474 8.02173 23 7.5754 23 6.90022C23 5.85737 22.1399 5 21.0781 5C20.4395 5 19.8498 5.2699 19.2788 5.97881C19.0901 6.21312 18.8059 6.35001 18.5051 6.35155C18.2043 6.35308 17.9187 6.21909 17.7276 5.98672C17.136 5.26726 16.542 5 15.9219 5Z'
        fill='#023F80'
      />
      <path
        d='M9.54851 6.90846C10.0287 6.6357 10.1969 6.02528 9.92415 5.54505C9.65138 5.06483 9.04096 4.89665 8.56073 5.16942C5.83938 6.71515 4 9.64213 4 13C4 17.9706 8.02944 22 13 22C15.1256 22 17.0784 21.263 18.6176 20.0318L23.2929 24.7071C23.6834 25.0976 24.3166 25.0976 24.7071 24.7071C25.0976 24.3166 25.0976 23.6834 24.7071 23.2929L20.0318 18.6176C20.3884 18.1717 20.7035 17.6913 20.9711 17.1822C21.2281 16.6933 21.0401 16.0887 20.5512 15.8317C20.0623 15.5748 19.4577 15.7628 19.2008 16.2516C18.0283 18.4823 15.6906 20 13 20C9.13401 20 6 16.866 6 13C6 10.3906 7.42728 8.11333 9.54851 6.90846Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const searchOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.75 3.5C6.74594 3.5 3.5 6.74594 3.5 10.75C3.5 14.7541 6.74594 18 10.75 18C12.4277 18 13.9722 17.4302 15.2007 16.4735L19.4636 20.7364C19.8151 21.0879 20.3849 21.0879 20.7364 20.7364C21.0878 20.3849 21.0878 19.8151 20.7364 19.4636L16.4735 15.2007C17.4302 13.9722 18 12.4277 18 10.75C18 6.74594 14.7541 3.5 10.75 3.5ZM10.75 5.3C7.74005 5.3 5.3 7.74005 5.3 10.75C5.3 13.76 7.74005 16.2 10.75 16.2C13.76 16.2 16.2 13.76 16.2 10.75C16.2 7.74005 13.76 5.3 10.75 5.3Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const searchSlashOutline = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.75 5.3C10.4008 5.3 10.06 5.33273 9.73041 5.39505C9.242 5.48738 8.77122 5.1663 8.67889 4.6779C8.58655 4.18949 8.90763 3.71871 9.39604 3.62637C9.83534 3.54332 10.288 3.5 10.75 3.5C14.7541 3.5 18 6.74594 18 10.75C18 11.2144 17.9562 11.6694 17.8723 12.1109C17.7795 12.5992 17.3084 12.9199 16.8201 12.827C16.3318 12.7342 16.0111 12.2631 16.104 11.7748C16.1669 11.4436 16.2 11.1011 16.2 10.75C16.2 7.74005 13.76 5.3 10.75 5.3Z'
        fill='#023F80'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.5 10.75C3.5 14.7541 6.74594 18 10.75 18C12.4269 18 13.9724 17.4297 15.2006 16.4735L19.4635 20.7364C19.815 21.0879 20.3848 21.0879 20.7363 20.7364C21.0877 20.3849 21.0877 19.8151 20.7363 19.4636L4.53627 3.2636C4.1848 2.91213 3.61495 2.91213 3.26348 3.2636C2.91201 3.61508 2.91201 4.18492 3.26348 4.5364L5.02648 6.2994C4.07033 7.52756 3.5 9.07295 3.5 10.75ZM5.3 10.75C5.3 13.76 7.74005 16.2 10.75 16.2C11.9307 16.2 13.0224 15.8254 13.9147 15.1876L6.31236 7.58527C5.6746 8.47762 5.3 9.56938 5.3 10.75Z'
        fill='#023F80'
      />
    </svg>
  );
};

export const searchEye = (props: any) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.031 14.617L20.314 18.899L18.899 20.314L14.617 16.031C13.0237 17.3082 11.042 18.0029 9 18C4.032 18 0 13.968 0 9C0 4.032 4.032 0 9 0C13.968 0 18 4.032 18 9C18.0029 11.042 17.3082 13.0237 16.031 14.617ZM14.025 13.875C15.2941 12.5699 16.0029 10.8204 16 9C16 5.132 12.867 2 9 2C5.132 2 2 5.132 2 9C2 12.867 5.132 16 9 16C10.8204 16.0029 12.5699 15.2941 13.875 14.025L14.025 13.875ZM10.178 5.176C9.88313 5.3092 9.62498 5.51195 9.42569 5.76686C9.22641 6.02176 9.09195 6.32121 9.03384 6.63951C8.97574 6.95781 8.99573 7.28546 9.09209 7.59433C9.18846 7.90321 9.35832 8.18409 9.58712 8.41288C9.81591 8.64168 10.0968 8.81154 10.4057 8.90791C10.7145 9.00427 11.0422 9.02426 11.3605 8.96616C11.6788 8.90805 11.9782 8.77359 12.2331 8.57431C12.4881 8.37502 12.6908 8.11687 12.824 7.822C13.0868 8.67562 13.0563 9.59265 12.7375 10.427C12.4186 11.2613 11.8297 11.9648 11.0646 12.4256C10.2994 12.8864 9.40208 13.0778 8.51552 12.9694C7.62896 12.8609 6.8042 12.4589 6.17264 11.8274C5.54108 11.1958 5.13906 10.371 5.03064 9.48448C4.92223 8.59792 5.11365 7.70058 5.5744 6.93544C6.03516 6.1703 6.73875 5.58138 7.57305 5.26252C8.40735 4.94366 9.32438 4.9132 10.178 5.176Z"
        fill="#121414"
      />
    </svg>
  );
};
